import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (

       <nav id="nav" className={isScrolled ? 'scrolled' : ''}>
        <div className="nav-inner">
        <div className="nav-logo">
            <div className="nav-logo-main">INVESTA<span>ESTATES</span></div>
            <div className="nav-logo-tag">Invest. Live. Prosper.</div>
        </div>

        <ul className="nav-links">
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#listings">Listings</a></li>
            <li><a href="#contact">Contact</a></li>
        </ul>

        <a className="nav-cta" href="#contact">Book Consultation</a>
        </div>
    </nav>

  );
};

export default Header;